import { render, staticRenderFns } from "./ClubEvents.vue?vue&type=template&id=3ec73758&scoped=true"
import script from "./ClubEvents.vue?vue&type=script&lang=js"
export * from "./ClubEvents.vue?vue&type=script&lang=js"
import style0 from "./ClubEvents.vue?vue&type=style&index=0&id=3ec73758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec73758",
  null
  
)

export default component.exports